import { useState, useEffect } from 'react';
import axios from 'axios';

export function useSuppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/payables/suppliers`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(r => setSuppliers(r.data))
      .catch(() => setSuppliers([]))
      .finally(() => setLoading(false));
  }, []);

  return { suppliers, loading };
}
